import React            from 'react';
import PropTypes        from 'prop-types';
// import classNames       from 'classnames';
import { Link }         from 'react-router-dom';

import Input                from '../../../components/Input';
import Button               from '../../../components/Button';
import Tooltip              from '../../../components/Tooltip';
import Icons                from '../../../../assets/svg/icons.js';

import { getErrorsText }    from '../../../../utils/errors.js';

import styles               from '../AccountPage.styl';

function AccountTab(props) {
    const {
        onChangeTab,
        onChange,
        values,
        errors
    } = props;

    return  (
        <div
            className = {styles.AccountTab}
        >
            <h2 className={styles.title}>
                Create Account
            </h2>
            <div className={styles.formBlock}>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Company name
                        <Tooltip
                            content = 'Specify the real name of the company, this will help, if necessary, to restore accesses and passwords.'
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder='Where do you work ?'
                        className={styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('name')}
                        value          = {values.name}
                        error          = {getErrorsText(errors.name)}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Organization URL
                        <Tooltip
                            content = {
                                <>
                                    {'Enter the name that will be used when generating the URL for your service. All letters must be entered in Latin and lower case.'}
                                    <Icons.OrgUrl className={styles.urlIcon} />
                                </>
                            }
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder    = 'Enter Organization URL'
                        className      = {styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('url')}
                        value          = {values.url}
                        error          = {getErrorsText(errors.url)}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        First Name
                        <Tooltip
                            content = 'Enter your real name, this will help you recover accesses and passwords if necessary.'
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder    = 'First Name'
                        className      = {styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('firstName')}
                        value          = {values.firstName}
                        error          = {getErrorsText(errors.firstName)}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Last Name
                        <Tooltip
                            content = 'Enter your real name, this will help you recover accesses and passwords if necessary.'
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder='Last Name'
                        className={styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('lastName')}
                        value          = {values.lastName}
                        error          = {getErrorsText(errors.lastName)}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Email
                        <Tooltip
                            content = 'Please enter a valid email address, a link to your account and access will be sent to it. An email address is also needed to reset your password.'
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder='Email'
                        className={styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('email')}
                        value          = {values.email}
                        error          = {getErrorsText(errors.email)}
                    />
                </div>
                <div className={styles.inputBlock}>
                    <div className={styles.label}>
                        Phone number
                        <Tooltip
                            content = 'Please enter a valid phone number. This will help restore access, password, if necessary.'
                        >
                            <div className={styles.infoWrapper}>
                                <Icons.TooltipInfo
                                    className={styles.infoIcon}
                                />
                            </div>
                        </Tooltip>
                    </div>
                    <Input
                        placeholder='Phone number'
                        className={styles.inputWrapper}
                        inputClassName = {styles.input}
                        onChange       = {onChange('phone')}
                        value          = {values.phone}
                        error          = {getErrorsText(errors.phone)}
                    />
                </div>
                <div className={styles.checkboxBlock}>
                    <div className={styles.agreeText}>
                        By signing up, you agree to Revealbot
                        <Link
                            to        = '/terms'
                            className = {styles.link}
                        >
                            {' Terms of Service '}
                        </Link>
                        and
                        <Link
                            to        = '/privacy-policy'
                            className = {styles.link}
                        >
                            {' Privacy policy'}
                        </Link>
                    </div>
                </div>
                <Button
                    className = {styles.button}
                    color     = 'gradient'
                    onClick   = {onChangeTab('company')}
                >
                        Create Account
                </Button>
                <div className={styles.haveAccount}>
                        Already have an account?
                </div>
            </div>
        </div>
    );
}

AccountTab.propTypes = {
    className   : PropTypes.string,
    onChangeTab : PropTypes.func.isRequired,
    onChange    : PropTypes.func.isRequired,
    values      : PropTypes.object.isRequired,
    errors      : PropTypes.object.isRequired
};

AccountTab.defaultProps = {
    className : ''
};

export default AccountTab;
